export var PrimitiveTypes;
(function (PrimitiveTypes) {
    PrimitiveTypes[PrimitiveTypes["String"] = 0] = "String";
    PrimitiveTypes[PrimitiveTypes["Number"] = 1] = "Number";
    PrimitiveTypes[PrimitiveTypes["Boolean"] = 2] = "Boolean";
    PrimitiveTypes[PrimitiveTypes["Date"] = 3] = "Date";
    PrimitiveTypes[PrimitiveTypes["Null"] = 4] = "Null";
    PrimitiveTypes[PrimitiveTypes["Undefined"] = 5] = "Undefined";
})(PrimitiveTypes || (PrimitiveTypes = {}));
